import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const bgTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Име (малки букви, без специални знаци)',
    add: 'Добавете',
    allowedFileTypes: 'Разрешени типове файлове',
    allowedFileTypesDescription:
      'Ограничете разрешените типове файлове (напр. изображение/*, приложение/pdf). Оставете празно, за да разрешите всички типове.',
    allowMultipleFiles: 'Разрешаване на множество файлове',
    amountInCents: 'Сума в центове',
    basePrice: 'Основна цена',
    bcc: 'BCC',
    brand: 'Марка',
    cc: 'CC',
    checkboxPlural: 'Полета за отметка',
    checkboxSingular: 'Квадратче за отметка',
    checkedByDefault: 'Отметнато по подразбиране',
    chooseConfirmationType:
      'Изберете дали да показвате съобщение на страницата или да пренасочвате към друга страница, след като изпратят формуляра.',
    condition: 'Състояние',
    confirmationMessage: 'Съобщение за потвърждение',
    confirmationType: 'Тип потвърждение',
    countryPlural: 'Country Fields',
    countrySingular: 'държава',
    creditCard: 'Кредитна карта',
    customURL: 'Персонализиран URL адрес',
    datePlural: 'Полета за дата',
    dateSingular: 'Дата',
    defaultValue: 'Стойност по подразбиране',
    divide: 'Разделяне',
    documentToLinkTo: 'Документ за връзка',
    doesNotEqual: 'Не е равно',
    emailFrom: 'Имейл от',
    emailPlural: 'Имейл полета',
    emailsDescription:
      'Изпращайте персонализирани имейли, когато формулярът бъде изпратен. Използвайте списъци, разделени със запетая, за да изпратите един и същи имейл до множество получатели. За да посочите стойност от този формуляр, увийте името на това поле с двойни къдрави скоби, т.е. {{firstName}}. Можете да използвате заместващ знак {{*}} за извеждане на всички данни и {{*:table}} за форматиране като HTML таблица в имейла.',
    emailSingular: 'Имейл',
    emailTo: 'Имейл до',
    equals: 'Равно',
    field: 'Поле',
    fields: 'Полета',
    fieldWidth: 'Ширина на полето (процент)',
    hasAnyValue: 'Има някаква стойност',
    internalLink: 'Вътрешна връзка',
    label: 'Етикет',
    maxFileSize: 'Макс. размер на файла (байтове)',
    maxFileSizeDescription:
      'Максимален размер на файла в байтове. Оставете празно за без ограничение.',
    message: 'Съобщение',
    messageDescription: 'Въведете съобщението, което трябва да бъде изпратено в този имейл.',
    messagePlural: 'Блокове за съобщения',
    messageSingular: 'Съобщение',
    mimeType: 'Тип MIME',
    mimeTypePlural: 'Типове MIME',
    mimeTypeSingular: 'Тип MIME',
    multiply: 'Умножете',
    numberPlural: 'Числови полета',
    numberSingular: 'Номер',
    optionPlural: 'Опции',
    optionSingular: 'опция',
    paymentFieldPlural: 'Полета за плащане',
    paymentFieldSingular: 'Плащане',
    paymentProcessor: 'Процесор на плащане',
    paymentStatus: 'Статус',
    placeholder: 'Заместител',
    priceConditions: 'Ценови условия',
    priceConditionsPlural: 'Ценови условия',
    priceConditionsSingular: 'Цена Състояние',
    radioOptions: 'Опции за радио атрибути',
    radioPlural: 'Радио полета',
    radioSingular: 'Радио',
    redirect: 'Пренасочване',
    replyTo: 'Отговор на',
    required: 'Задължително',
    selectOptions: 'Изберете Опции',
    selectPlural: 'Изберете Полета',
    selectSingular: 'Изберете',
    statePlural: 'Държавни полета',
    stateSingular: 'състояние',
    staticValue: 'Статична стойност',
    subject: 'Предмет',
    submitButton: 'Етикет на бутона за изпращане',
    subtract: 'Извадете',
    textareaPlural: 'Полета на текстовото поле',
    textareaSingular: 'Текстово поле',
    textPlural: 'Текстови полета',
    textSingular: 'Текст',
    title: 'Заглавие',
    token: 'жетон',
    uploadCollection: 'Качване на колекция',
    uploadCollectionDescription: 'Изберете в коя колекция за качване да съхранявате файлове',
    uploadFieldPlural: 'Качване на полета',
    uploadFieldSingular: 'Качване',
    urlToRedirectTo: 'URL за пренасочване',
    value: 'Стойност',
    valueOfField: 'Стойност на полето',
    valueType: 'Тип стойност',
  },
}

export const bg: PluginLanguage = {
  dateFNSKey: 'bg',
  translations: bgTranslations,
}
